module.exports = __webpack_public_path__ + "9e85cc57ef8c67142d1b30bac8e562be.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/colourScale/F@2x.png
// module id = 821
// module chunks = 0